var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */
        /* jshint strict: false */
        /* global app */

        eventDispatcher.addEvent('click', '.js-close-page', function (e) {
            e.preventDefault();

            window.close();
        });

        window.formatDateDayMonthYear = function (dateStr) {
            var date = new Date(dateStr);
            var day = String(date.getDate()).padStart(2, '0');
            var month = String(date.getMonth() + 1).padStart(2, '0'); // месяцы с 0
            var year = date.getFullYear();
            return day + "." + month + "." + year;
        };

        window.isWhatsappCallCenterWorkTime = function () {
            var now = new Date();
            var day = now.getDay(); // 0 (воскресенье) – 6 (суббота)
            var hour = now.getHours();
            var minute = now.getMinutes();

            var currentMinutes = hour * 60 + minute;

            // Время когда вместо колл-центра работает отдел чата
            var schedule = {
                1: [[8 * 60, 10 * 60], [18 * 60, 21 * 60]], // Пн
                2: [[8 * 60, 10 * 60], [18 * 60, 21 * 60]], // Вт
                3: [[8 * 60, 10 * 60], [18 * 60, 21 * 60]], // Ср
                4: [[8 * 60, 10 * 60], [18 * 60, 21 * 60]], // Чт
                5: [[8 * 60, 10 * 60], [18 * 60, 21 * 60]], // Пт
                6: [[8 * 60, 11 * 60], [15 * 60, 21 * 60]], // Сб
                0: [[8 * 60, 21 * 60]] // Вс
            };

            var todaySchedule = schedule[day] || [];

            var isOnlineDepartmentTime = todaySchedule.some(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    start = _ref2[0],
                    end = _ref2[1];

                return currentMinutes >= start && currentMinutes < end;
            });

            return !isOnlineDepartmentTime;
        };

        window.getWhatsappPhone = function () {
            var cityWhatsAppPhone = void 0;
            var userCityId = window.getCookieByName('city_id') || app.defaultCity.id;
            cityWhatsAppPhone = app.citiesWhatsAppPhones[userCityId] || window.citiesWhatsAppPhones[app.defaultCity.id];
            return cityWhatsAppPhone;
        };
    }, {}] }, {}, [1]);